import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f129cf28"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "account" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"18px","font-weight":"bold"} }, "全国招商项目统计", -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode("搜索")

import { defineComponent } from "vue";
import store from "@/store/index";
import { useStore } from "@/store/index";
import { ref, reactive } from "vue";
import tool from "@/utils/tool";
import router from "@/router/index";
import { ElButton, ElMessage, ElMessageBox } from "element-plus";
import type { ElForm, Action } from "element-plus";

interface ActivitySeasonStatVo {
  companyCode: string;
  companyName: string;
  totalCount: string;
  seasonA: string;
  seasonB: string;
  seasonC: string;
  seasonD: string;
  seasonE: string;
  applyCount: string;
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const ustore = useStore();
const loading = ref(true);

const bindData = reactive({
  seasonNames: ['', '', '', '', ''],
  pageParams: {
    curPage: 1,
    pageSize: 10,
    filtrate: {
      type: "1",
      keyword: "",
    },
  },
  pageResult: {
    status: 2000,
    msg: "成功",
    result: new Array<ActivitySeasonStatVo>(),
    totalCount: 0,
  },
});

const handleSizeChangeEvent = (value: any) => {
  bindData.pageParams.pageSize = value;
  bindData.pageParams.curPage = 1;
  searchEvent();
};

const handleCurrentChangeEvent = (value: any) => {
  bindData.pageParams.curPage = value;
  searchEvent();
};

const listSeason = () => {
  store
    .dispatch("frontInvestModule/listSeason")
    .then(
      (data) => {
        //成功
        bindData.seasonNames = data.result;
      },
      (error) => {
        console.log(error.msg);
      }
    );
};

listSeason();

const searchEvent = () => {
  store
    .dispatch("frontInvestModule/pageSumBySeasonStat", bindData.pageParams)
    .then(
      (data) => {
        //成功
        bindData.pageResult = data;
        loading.value = false;
      },
      (error) => {
        console.log(error.msg);
      }
    );
};

searchEvent();


return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, { class: "account-search" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, { class: "account-search-lt" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { class: "account-search-lt-text" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  placeholder: "发布主体名称",
                  size: "large",
                  modelValue: _unref(bindData).pageParams.filtrate.keyword,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(bindData).pageParams.filtrate.keyword) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { class: "account-search-lt-btn" }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElButton), {
                  type: "primary",
                  size: "large",
                  onClick: searchEvent
                }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      data: _unref(bindData).pageResult.result,
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "companyName",
          label: "项目发布主体",
          width: "180"
        }),
        _createVNode(_component_el_table_column, {
          prop: "totalCount",
          label: "累计项目数",
          width: "150"
        }),
        _createVNode(_component_el_table_column, {
          prop: "seasonA",
          label: _unref(bindData).seasonNames[0],
          width: "100"
        }, null, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          prop: "seasonB",
          label: _unref(bindData).seasonNames[1],
          width: "100"
        }, null, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          prop: "seasonC",
          label: _unref(bindData).seasonNames[2],
          width: "100"
        }, null, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          prop: "seasonD",
          label: _unref(bindData).seasonNames[3],
          width: "100"
        }, null, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          prop: "seasonE",
          label: _unref(bindData).seasonNames[4],
          width: "100"
        }, null, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          prop: "applyCount",
          label: "累计报名数",
          width: "150"
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, loading.value]
    ]),
    _createVNode(_component_el_container, { class: "account-page_toolbar" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_pagination, {
          currentPage: _unref(bindData).pageParams.curPage,
          "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((_unref(bindData).pageParams.curPage) = $event)),
          "page-size": _unref(bindData).pageParams.pageSize,
          "onUpdate:page-size": _cache[2] || (_cache[2] = ($event: any) => ((_unref(bindData).pageParams.pageSize) = $event)),
          "page-sizes": [10, 20, 50, 100],
          layout: "total, sizes, prev, pager, next, jumper",
          total: _unref(bindData).pageResult.totalCount,
          "onUpdate:total": _cache[3] || (_cache[3] = ($event: any) => ((_unref(bindData).pageResult.totalCount) = $event)),
          onSizeChange: handleSizeChangeEvent,
          onCurrentChange: handleCurrentChangeEvent
        }, null, 8, ["currentPage", "page-size", "total"])
      ]),
      _: 1
    })
  ]))
}
}

})